// @flow
import * as React from 'react'
import styled from 'styled-components'
import BlockListItem, { type Size } from 'ui/atoms/BlockListItem'
import Text from 'ui/atoms/Text'

type Props = {
  items: Array<{|
    label: string,
    active: boolean,
    onClick: () => void,
    className?: string,
  |}>,
  size?: Size,
  className?: string,
}

const StyledList = styled.ul`
  > li:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  > li:last-child {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`

function BlockList({ items, size, className }: Props): React.Node {
  return (
    <StyledList className={className}>
      {items.map(({ label, ...item }, index) => (
        <BlockListItem key={index} size={size} {...item}>
          <Text $small>{label}</Text>
        </BlockListItem>
      ))}
    </StyledList>
  )
}

export default BlockList
